import React, {useEffect} from "react";
import Card from "src/componets/Card";
import { AppInterface } from "src/store/community/appsSlice";
import { Button, Form, Input, message, Select } from "antd";
import FileDropzone from "src/componets/FileDropzone";
import {filterOption, objToFormData} from "src/helpers/FormHelper";
import { updateApp } from "src/actions/community/appsActions";
import {useAppDispatch, useAppSelector} from "src/store/hooks";
import { fetchTemplates } from "src/actions/sendgrid/templatesActions";
import { fetchSenders } from "src/actions/sendgrid/sendersActions";
import TemplatesSelect from "src/pages/sendgrid/_partials/_TemplatesSelect";
import { EntityId } from "@reduxjs/toolkit";

const _Email = ({ app }: { app: AppInterface | undefined }) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const senderIds = useAppSelector(state => state.sendgrid.senders.ids);
  const senders = useAppSelector(state => state.sendgrid.senders.entities);
  const status = useAppSelector(state => state.sendgrid.senders.status);

  useEffect(() => {
    dispatch(fetchTemplates());
    dispatch(fetchSenders());
  }, [dispatch]);

  useEffect(() => {
    form.resetFields();
  }, [app, form]);

  function onFinish(data: AppInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: AppInterface) {
    if (app) {
      const formData = objToFormData(data);
      const resultAction = await dispatch(updateApp({ id: app.id, data: formData }));

      if (updateApp.fulfilled.match(resultAction)) {
        message.success('Email settings updated successfully');
      }
    }
  }

  const renderSenderOption = (id: EntityId) => {
    const item = senders[id];

    if (!item) {
      return null;
    }

    return <Select.Option key={id} value={item.email} title={item.email}>{item.email}</Select.Option>
  }

  const SelectSenders = () => (
    <Form.Item
      name='email'
      label="Sender"
      extra='for development you can use support@apps4you.tf'
    >
      <Select
        allowClear
        showSearch
        filterOption={filterOption}
        placeholder='Select a sender'
        loading={status === 'loading'}
      >
        {senders && senderIds.map(renderSenderOption)}
      </Select>
    </Form.Item>
  )

  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Email settings</h4>

        <Form
          form={form}
          onFinish={values => onFinish(values)}
          layout="vertical"
          className='v-form v-app-email_form'
          initialValues={app}
        >
          <FileDropzone name='icon' label='Icon' preview={app?.icon_url} />

          <SelectSenders />

          <Form.Item name='email_name' label="Name">
            <Input placeholder='name' />
          </Form.Item>

          <h6 className="v-content-label o-sm">Templates</h6>
          <TemplatesSelect />

          <Form.Item>
            <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </>
  );
}

export default _Email;
